<div class="content-header">
  <h2>{{ tituloBandeja }}</h2>
</div>

<form class="filter-bar" [formGroup]="filtrosForm" (ngSubmit)="buscar()">
  @if(!mostrarSeleccion){
  <div class="contFiltr">
    <div class="up">Filtrar por fecha:</div>
    <div class="down">
      <ng-select [clearable]="false" placeholder="Seleccione una opción" id="tipo-filtro" formControlName="tipoFiltro">
        <ng-option [value]="1">Fecha de determinación</ng-option>
        <ng-option [value]="2">Fecha de publicación</ng-option>
        <ng-option [value]="4">Fecha de recepción</ng-option>
        <ng-option [value]="3">Fecha de notificación</ng-option>
      </ng-select>

    </div>
  </div>
  }

  @if(!mostrarSeleccion){
  <div class="contFiltr">
    <div class="up">Rango de fechas:</div>
    <div class="down">
      <input type="date" class="date-input eligeFecha" formControlName="fechaInicio" />&nbsp;
      <input type="date" class="date-input eligeFecha" formControlName="fechaFin" />&nbsp;
      <button type="submit" class="btn-search">
        <i class="fas fa-search"></i> Buscar
      </button>
    </div>
  </div>
  }

  @if(mostrarSeleccion){
  <div class="contFiltr">
    <div class="up">Actualizar lista:</div>
    <div class="down">
      <button type="button" class="btn-search" (click)="refrescarNoNotificados()">
        Actualizar
      </button>
    </div>
  </div>
  }


  <div class="separador"></div>

  <div class="contFiltr">
    <div class="up">Filtro general:</div>
    <div class="down search-right">
      <i class="fas fa-search icon"></i>
      <input type="text" placeholder="Búsqueda general" formControlName="filtroGeneral"
        (input)="onFilterInputChange()" />
    </div>
  </div>

</form>

@if(loading){
<div class="loading-overlay">
  <div class="loading-indicator">Cargando notificaciones...</div>
</div>
}

@if(!loading && errorMessage){
<div class="alert alert-danger">
  {{ errorMessage }}
</div>
}

@if(!loading && successMessage){
<div class="alert alert-success">
  {{ successMessage }}
</div>
}

@if(filteredNotificaciones.length){
<div class="table-controls">
  <label>
    Elementos por página:
    <select [value]="pageSize" (change)="onPageSizeChange($event)">
      @for(size of pageSizes; track $index) {
      <option [value]="size">{{ size }}</option>
      }
    </select>
  </label>
  @if(iEstatus && +iEstatus=== 4){
  <oaj-exportar-excel [data]="filtrosForm.get('filtroGeneral')?.value ? filteredNotificaciones : notificaciones"
    [columns]="columnasReporte" [fileName]=" 'Reporte '+tituloBandeja+'.xlsx' " [supertitle]="nombreAutoridad">
  </oaj-exportar-excel>
  }
  @else {
  <oaj-exportar-excel [data]="filtrosForm.get('filtroGeneral')?.value ? filteredNotificaciones : notificaciones"
    [columns]="columnasReporte" [fileName]=" 'Reporte '+tituloBandeja+'.xlsx' "
    [subtitle]=" subtituloReporte + ': ' + periodoFechaInicio + ' - ' + periodoFechaFin "
    [supertitle]="nombreAutoridad">
  </oaj-exportar-excel>
  }

</div>
}


@if(filteredNotificaciones.length){
<div class="table-container">
  <table>
    <thead>
      <tr>
        @if(mostrarSeleccion && !bOrganoSupervisado){      
        <th class="selection-col">
          <div class="selection-header">
            <span>Selección</span>
            <input type="checkbox" [checked]="estaSeleccionadoTodo" (change)="onToggleSelectAll($event)" />
          </div>
        </th>        
        }

        <th>#</th>
        <th class="hidden-col">idNotificacionICOIJ</th>
        <th class="hidden-col">estatus</th>
        <th class="hidden-col">idOrgano</th>
        <th>Circuito</th>
        <th>Órgano Jurisdiccional PJF</th>
        <th>NEUN</th>
        <th>Expediente</th>
        <th>Tipo asunto</th>
        <!--    <th>Autoridad</th> -->
        <th>Tipo Cuaderno</th>
        <th>Fecha Determinación</th>
        <th>Fecha Publicación</th>
        <th>Fecha Recepción</th>
        <!-- <th>Folio Envío</th> -->
        <!--    <th>Fecha Envío</th> -->
        <!--         <th *ngIf="esEstatusNotificados()">Folio Respuesta</th> -->
        @if(esEstatusNotificados()){
        <th>Tipo de constancia</th>
        }
        @if(!mostrarSeleccion){
        <th>Fecha Notificación</th>
        <th>Archivos</th>
        <th>Constancia de notificación</th>
        }
       <th>Nombre de la Autoridad</th>
       <th>Carácter de la Autoridad</th>
      </tr>
    </thead>
    <tbody>
      @for(notificacion of pagedNotificaciones; track trackByNotificacion($index, notificacion); let i = $index){
      <tr [class.selectable-row]="mostrarSeleccion"
        [class.row-selected]="mostrarSeleccion && isSeleccionada(notificacion)">
        @if(mostrarSeleccion && !bOrganoSupervisado){
        <td class="selection-col">
          <input type="checkbox" [checked]="isSeleccionada(notificacion)"
            (change)="onToggleNotificacion(notificacion, $event)" />
        </td>
        }
        <td>{{ startItemIndex + i }}</td>
        <td class="hidden-col">{{ notificacion.idNotificacionICOIJ }}</td>
        <td class="hidden-col">{{ notificacion.estatus }}</td>
        <td class="hidden-col">{{ notificacion.idOrgano }}</td>
        <td>{{ notificacion.circuito }}</td>
        <td>{{ notificacion.organoJurisdiccionalPJF }}</td>
        <td>{{ notificacion.neun }}</td>
        <td>{{ notificacion.expediente }}</td>
        <td>{{ notificacion.tipoAsunto }}</td>
        <!--    <td>{{ notificacion.autoridad }}</td> -->
        <td>{{ notificacion.sTipoCuaderno }}</td>
        <td>
          <div>{{ notificacion.fechaAcuerdo | date: 'dd/MM/yyyy' }}</div>
        </td>
        <td>
          <div>{{ notificacion.fechaPublica | date: 'dd/MM/yyyy' }}</div>
        </td>
        <td>
          <div>{{ notificacion.fechaRecepcion | date: 'dd/MM/yyyy' }}</div>
        </td>
        <!-- <td>{{ notificacion.folioEnvio === 0 ? '' : notificacion.folioEnvio }}</td> -->
        <!--       <td>
          <div>{{ notificacion.fechaEnvio | date: 'dd/MM/yyyy' }}</div>
          <div>{{ notificacion.fechaEnvio | date: 'HH:mm' }}</div>
        </td> -->
        <!--  <td *ngIf="esEstatusNotificados()">{{ notificacion.folioRespuesta }}</td> -->
        <!--      <td *ngIf="esEstatusNotificados()">{{ getTipoConstancia(notificacion) }}</td> -->
        @if(esEstatusNotificados()){
        <td>{{ notificacion.TipoNotificacion }}</td>
        }
        @if(!mostrarSeleccion){
        <td>
          @if(notificacion.fechaNotificacion)
          {
          <ng-container>
            <div>{{ notificacion.fechaNotificacion | date: 'dd/MM/yyyy' }}</div>
            <div>{{ notificacion.fechaNotificacion | date: 'HH:mm' }}</div>
          </ng-container>
          }
          @else {
          <ng-template #sinFecha>Sin valor</ng-template>
          }

        </td>
        }
        @if(!mostrarSeleccion){
        <td class="icon-cell">
          <button type="button" class="icon-button" (click)="abrirModal('archivos', notificacion)">
            <i class="fas fa-file-alt"></i>
          </button>
        </td>
        }
        @if(!mostrarSeleccion){
        <td class="icon-cell">
          <button type="button" class="icon-button" (click)="abrirModal('constancia', notificacion)">
            <i class="fas fa-scroll"></i>
          </button>
        </td>
        }
         <td>{{ notificacion.autoridad }}</td>
         <td>{{ notificacion.caracterAutoridad }}</td>
      </tr>
      }

    </tbody>
  </table>
</div>
}

@if(!loading && !errorMessage && !filteredNotificaciones.length){
<div class="alert alert-info">
  No se encontraron notificaciones para los filtros seleccionados.
</div>
}

@if(filteredNotificaciones.length){
<div class="pagination-bar">
  <span>{{ startItemIndex }}-{{ endItemIndex }} de {{ totalItems }}</span>
  <div class="pagination-buttons">
    <button type="button" class="pagination-button" (click)="goToPreviousPage()" [disabled]="+currentPage === 1">
      Anterior
    </button>
    <button type="button" class="pagination-button" (click)="goToNextPage()" [disabled]="+currentPage === totalPages">
      Siguiente
    </button>
  </div>
</div>
}

@if(mostrarSeleccion && filteredNotificaciones.length && !bOrganoSupervisado){
<div class="action-bar">
  <button type="button" class="btn-notificarme" (click)="notificarSeleccion()"
    [disabled]="!listaNotificacionesParaNotificar.length">
    Notificarme
  </button>
</div>
}



<ng-template #modalArchivos let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Archivos de la notificación</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if(archivosModalLoading){
    <div>Cargando archivos...</div>
    }
    @if(!archivosModalLoading && archivosModalError)
    {
    <div class="alert alert-danger">
      {{ archivosModalError }}
    </div>
    }
    @if(!archivosModalLoading && !archivosModalError){
    <div>
      <oaj-lista-archivos-itx [archivos]="archivosModal" [verBorrar]="false" [verPrevisualizar]="true"
        [verClasificacion]="true" [verArchivoEnvio]="true"></oaj-lista-archivos-itx>
      @if(!archivosModal.length){
      <div class="alert alert-info">
        No se encontraron archivos para esta notificación.
      </div>
      }
    </div>
    }
  </div>
</ng-template>

<ng-template #modalConstancia let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Constancia de notificación</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" id="constancia-content">
    <div class="d-flex align-items-center justify-content-center constancia-logo">
      <img src="assets/img/poderjudicial_grey.png" alt="Logo"
        style="width: 143px; height: 137px; margin-bottom: 14px;" />
    </div>
    <div class="constancia-titulo">CONSTANCIA DE NOTIFICACIÓN</div>
    <div class="constancia-subtitulo">
      Órgano Jurisdiccional que envía: {{ notificacionConstancia?.organoJurisdiccionalPJF }}
    </div>
    <div class="constancia-subtitulo">
      Nombre de la Autoridad: {{ notificacionConstancia?.autoridad }}
    </div>
    <div class="constancia-subtitulo">
      Autoridad interconexión notificada: {{ notificacionConstancia?.nombreAutoridad }}
    </div>
    @if(notificacionConstancia?.iTipoNotificacion === 2){
    <div class="constancia-subtitulo">
      Notificación realizada por: Automática
    </div>
    }
    @else {
    <div class="constancia-subtitulo">
      Notificación realizada por: {{ notificacionConstancia?.autoridaRealizaNot }}
    </div>
    }
    <div class="constancia-section">
      <table class="constancia-table">
        <thead>
          <tr>
            <th colspan="2">Información general</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Folio de recepción</td>
            <td>{{ notificacionConstancia?.folioRespuesta }}</td>
          </tr>
          <tr>
            <td>Fecha de notificación</td>
            <td>{{ notificacionConstancia?.fechaNotificacion | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <td>Hora de notificación</td>
            <td>{{ notificacionConstancia?.fechaNotificacion | date: 'HH:mm' }}</td>
          </tr>
          <tr>
            <td>Número de expediente</td>
            <td>{{ notificacionConstancia?.expediente || 'Sin valor' }}</td>
          </tr>
          <tr>
            <td>NEUN</td>
            <td>{{ notificacionConstancia?.neun ?? 'Sin valor' }}</td>
          </tr>
          <tr>
            <td>Tipo de asunto</td>
            <td>{{ notificacionConstancia?.tipoAsunto || 'Sin valor' }}</td>
          </tr>
          <tr>
            <td>Cuaderno</td>
            <td>{{ notificacionConstancia?.sTipoCuaderno || 'Sin valor' }}</td>
          </tr>
          <tr>
            <td>Fecha del acuerdo</td>
            <td>{{ notificacionConstancia?.fechaAcuerdo | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <td>Fecha de publicación del acuerdo</td>
            <td>{{ notificacionConstancia?.fechaPublica | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <td>Síntesis del acuerdo</td>
            <td>{{ notificacionConstancia?.sintesis || 'Sin valor' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- ART 040326: Se comenta esta sección porque se decidió no mostrar los archivos recibidos en la constancia, pero se deja el código por si en el futuro se quiere volver a habilitar esta funcionalidad. -->
    <!--     <div class="constancia-section">
      <table class="constancia-table">
        <thead>
          <tr>
            <th colspan="4">Archivos recibidos</th>
          </tr>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Tamaño</th> 
            <th>Clasificación</th>
          </tr>
        </thead>
        <tbody *ngIf="!constanciaLoading && !constanciaError">
          <tr *ngFor="let archivo of constanciaArchivos; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ archivo.nombreOriginal }}</td>
             <td>{{ archivo.tamanio }} KB</td>
            <td>{{ getClasificacionDescripcion(archivo.iClasificacion) }}</td>
          </tr>
          <tr *ngIf="!constanciaArchivos.length">
            <td colspan="4">No se encontraron archivos.</td>
          </tr>
        </tbody>
        <tbody *ngIf="constanciaLoading">
          <tr>
            <td colspan="4">Cargando archivos...</td>
          </tr>
        </tbody>
        <tbody *ngIf="!constanciaLoading && constanciaError">
          <tr>
            <td colspan="4" class="text-danger">{{ constanciaError }}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <div class="constancia-section">
      @if(notificacionConstancia?.iTipoNotificacion === 2){
      <div class="text-muted me-auto">
        La notificación realizada el {{ notificacionConstancia?.fechaNotificacion | date: 'dd/MM/yyyy' }} a las {{
        notificacionConstancia?.fechaNotificacion | date: 'HH:mm' }} ha surtido efectos al haber transcurrido el plazo
        previsto en {{leyenda}}.
      </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-envio" (click)="imprimirConstancia()">Imprimir PDF</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>